var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone30X30(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/phone/30x30") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/phone/30x30",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "telephone-6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9664524,24.4742708 C29.8055036,25.8714121 29.2560067,27.1954259 28.3803662,28.2959485 C27.4515252,29.4101423 26.0634532,30.0374248 24.6134116,29.9982701 C21.3248389,30.0019495 18.0693823,29.3415516 15.042202,28.0566664 C5.92819519,24.2094689 0.00344686014,15.2791861 0.00172988807,5.38639222 C-0.0374245346,3.93633909 0.589853006,2.54825604 1.70403787,1.61940758 C2.80455175,0.743760075 4.12855499,0.194258823 5.52568512,0.0333087786 C6.43969529,-0.095200287 7.36682836,0.151379623 8.09623854,0.716972053 C8.14357638,0.748423444 8.1851943,0.78772957 8.21929695,0.83319481 L11.4803448,4.96935762 C12.4501928,6.2510578 12.3961252,8.03530313 11.3504498,9.25592635 L10.3659825,10.2882579 L9.57293945,11.1154905 C9.75069048,13.5356584 12.2665513,16.5369402 15.042202,18.4785439 C16.2089143,19.3477079 17.5284443,19.9900852 18.9322151,20.3722912 L19.7184216,19.6339349 L20.7233986,18.6768063 C21.9382053,17.6134935 23.7313071,17.5450757 25.0236063,18.5127271 L29.1734093,21.7943108 L29.2896311,21.9105336 C29.8509933,22.6392374 30.0949795,23.5634348 29.9664524,24.4742708 L29.9664524,24.4742708 Z",
    id: "Path",
    fill: "#F41381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9664524,24.4742708 C29.8055036,25.8714121 29.2560067,27.1954259 28.3803662,28.2959485 C27.4515252,29.4101423 26.0634532,30.0374248 24.6134116,29.9982701 C21.3248389,30.0019495 18.0693823,29.3415516 15.042202,28.0566664 L15.042202,18.4853806 C16.2089143,19.3545445 17.5284443,19.9969219 18.9322151,20.3791278 L19.7184216,19.6407715 L20.7233986,18.6836429 C21.9382053,17.6203301 23.7313071,17.5519123 25.0236063,18.5195637 L29.1734093,21.7943108 L29.2896311,21.9105336 C29.8509933,22.6392374 30.0949795,23.5634348 29.9664524,24.4742708 L29.9664524,24.4742708 Z",
    id: "Path",
    fill: "#C60E68"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone30X30);
export default __webpack_public_path__ + "static/media/phone_30x30.265c6f0a1a0fca12453512c6114fe00c.svg";
export { ForwardRef as ReactComponent };